import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";
import MoreVert from "@material-ui/icons/MoreVert";
import ViewList from "@material-ui/icons/ViewList";
import Reply from "@material-ui/icons/Reply";
import HeaderLinksCustomized from "./HeaderLinksCustomized";

// core components
import AddUsersHeader from "./AddUsersHeader";
import TransactionListingHeader from "./TransactionListingHeader";
import RatingsHeader from "./RatingsHeader";
import Button from "../../components/CustomButtons/Button.jsx";

import { hist } from "../../index";

import headerStyle from "../../assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";
import ManageCategoryHeader from "./ManageCategoryHeader";

import ManageCustomersHeader from "./ManageCustomersHeader";
import ManageQuestionHeader from "./ManageQuestionHeader";
import ManageFlightHeader from "./ManageFlightHeader";
import ManageOfficerHeader from "./ManageOfficerHeader";
import CommonBack from "./commonBackButton";
import ManageDeclarationHeader from "./ManageDeclarationHeader";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showProductBack: false,
      showImageBack: false,
      showUserBack: false,
      showNotificationBack: false,
      showContentBack: false,
      msg: "",
      currentCatFaqId: null,
    };
  }

  makeBrand = () => {
    var name;
    this.props.routes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      }
      if (prop.path === this.props.location.pathname) {
        name = prop.name;
      }
      return null;
    });
    return name;
  };

  componentWillReceiveProps = () => {};

  backToRoute = (route, data) => {
    hist.push(`/${route}`, data);
  };

  render() {
    const { classes, color, rtlActive } = this.props;
    let pathName = this.props.location.pathname;
    let viewCheck;
    if (
      pathName.match("viewFlight") ||
      pathName.match("viewDeclaration") ||
      pathName.match("editQuestion") ||
      pathName.match("editFlight") ||
      pathName.match("viewQuestion") ||
      pathName.match("editCategory") ||
      pathName.match("viewCategory")
    ) {
      viewCheck = true;
    }

    const appBarClasses = cx({
      [" " + classes[color]]: color,
    });
    const sidebarMinimize =
      classes.sidebarMinimize +
      " " +
      cx({
        [classes.sidebarMinimizeRTL]: rtlActive,
      });
    return (
      <div>
        <AppBar className={classes.appBar + appBarClasses}>
          <Toolbar className={classes.container}>
            <Hidden smDown implementation="css">
              <div className={sidebarMinimize}>
                {this.props.miniActive ? (
                  <Button
                    justIcon
                    round
                    color="white"
                    onClick={this.props.sidebarMinimize}
                  >
                    <ViewList className={classes.sidebarMiniIcon} />
                  </Button>
                ) : (
                  <Button
                    justIcon
                    round
                    color="white"
                    onClick={this.props.sidebarMinimize}
                  >
                    <MoreVert className={classes.sidebarMiniIcon} />
                  </Button>
                )}
              </div>
            </Hidden>
            <div className={classes.flex}>
              <Button href="#" className={classes.title} color="transparent">
                {this.makeBrand() || ""}
              </Button>
            </div>
            <Hidden smDown implementation="css">
              {/* {this.props.location.pathname === "/admin/manageCustomers" && (
                <ManageCustomersHeader rtlActive={rtlActive} />
              )} */}

              {/* {this.props.location.pathname === "/admin/viewuser" && (
                <AddUsersHeader rtlActive={rtlActive} />
              )} */}

              {this.props.location.pathname === "/admin/addQuestion" && (
                <CommonBack rtlActive={rtlActive} />
              )}

              {viewCheck && <CommonBack rtlActive={rtlActive} />}
              {this.props.location.pathname === "/admin/addFlight" && (
                <CommonBack rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/viewuser" && (
                <CommonBack rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/addCategory" && (
                <CommonBack rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/viewofficer" && (
                <CommonBack rtlActive={rtlActive} />
              )}

              {/* {
                this.props.location.pathname ==="/admin/manageCustomers" && (
                  <CommonBack rtlActive={rtlActive} />
                )
              } */}
              {this.props.location.pathname === "/admin/addOfficer" && (
                <CommonBack rtlActive={rtlActive} />
              )}
              {this.props.location.pathname === "/admin/viewDeclaration/" && (
                <ManageDeclarationHeader rtlActive={rtlActive} />
              )}

              {/* {this.props.location.pathname === "/admin/addQuestion" && (
                <CommonBack rtlActive={rtlActive} />
              )} */}

              {this.props.location.pathname === "/admin/viewTransactions" && (
                <TransactionListingHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/manageCategories" && (
                <ManageCategoryHeader rtlActive={rtlActive} />
              )}
              {this.props.location.pathname === "/admin/manageQuestions" && (
                <ManageQuestionHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/manageFlights" && (
                <ManageFlightHeader rtlActive={rtlActive} />
              )}
              {/* {this.props.location.pathname === "/admin/viewDeclaration/:id" && (
                <ManageDeclaration rtlActive={rtlActive} />
              )} */}

              {/* {this.props.location.pathname === "/admin/manageCustomers" && (
                <ManageCustomersHeader rtlActive={rtlActive} />
              )} */}
              {/* {this.props.location.pathname === "/admin/manageCustomOfficers" && (
                <ManageOfficerHeader rtlActive={rtlActive} />
              )} */}

              {this.props.location.pathname === "/admin/recurringFlights" && (
                <ManageFlightHeader rtlActive={rtlActive} recurring={true} />
              )}
              {this.props.location.pathname ===
                "/admin/manageKYC_Verification/view" && (
                <Button
                  color="primary"
                  round
                  //className={classes.marginRight}
                  onClick={() => hist.push("/admin/manageKYC_Verification")}
                >
                  <Reply className={classes.icons} /> Back
                </Button>
              )}
              {this.props.location.pathname === "/admin/adminOfficers/view" && (
                <Button
                  color="primary"
                  round
                  //className={classes.marginRight}
                  onClick={() => hist.push("/admin/adminOfficers")}
                >
                  <Reply className={classes.icons} /> Back
                </Button>
              )}

              {this.props.location.pathname ===
                "/admin/recurringFlights/view" && (
                <Button
                  color="primary"
                  round
                  //className={classes.marginRight}
                  onClick={() => hist.push("/admin/recurringFlights")}
                >
                  <Reply className={classes.icons} /> Back
                </Button>
              )}
              {this.props.location.pathname ===
                "/admin/recurringFlights/edit" && (
                <Button
                  color="primary"
                  round
                  //className={classes.marginRight}
                  onClick={() => hist.push("/admin/recurringFlights")}
                >
                  <Reply className={classes.icons} /> Back
                </Button>
              )}
              {this.props.location.pathname ===
                "/admin/recurringFlight/add" && (
                <Button
                  color="primary"
                  round
                  //className={classes.marginRight}
                  onClick={() => hist.push("/admin/recurringFlights")}
                >
                  <Reply className={classes.icons} /> Back
                </Button>
              )}

              {this.props.location.pathname === "/admin/rating-list" && (
                <RatingsHeader rtlActive={rtlActive} />
              )}
            </Hidden>
            <HeaderLinksCustomized rtlActive={rtlActive} />
            {this.props.location.pathname === "/dashboard/viewproducts" && (
              <Button
                color="info"
                round
                className={classes.marginRight}
                onClick={() => this.backToRoute("dashboard/products")}
              >
                <Reply className={classes.icons} /> Back
              </Button>
            )}

            <Hidden mdUp implementation="css">
              <Button
                className={classes.appResponsive}
                color="transparent"
                justIcon
                aria-label="open drawer"
                onClick={this.props.handleDrawerToggle}
              >
                <Menu />
              </Button>
            </Hidden>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
};

export default withStyles(headerStyle)(Header);
